import { render, staticRenderFns } from "./ListagemDeCartasDeCorrecao.vue?vue&type=template&id=7faaeaa4&scoped=true&"
import script from "./ListagemDeCartasDeCorrecao.vue?vue&type=script&lang=ts&"
export * from "./ListagemDeCartasDeCorrecao.vue?vue&type=script&lang=ts&"
import style0 from "./ListagemDeCartasDeCorrecao.vue?vue&type=style&index=0&id=7faaeaa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faaeaa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDialog,VIcon,VTooltip})
